import { useState, useEffect } from "react";
import { getTaxProInfo } from "../api";

interface UseLogoProps {
  businessLogo?: string; // Optional logo URL from props
  businessId?: string | null; // Business ID from query params
  fallbackImage: string; // Custom fallback image
}

const useLogo = ({ businessLogo, businessId, fallbackImage }: UseLogoProps) => {
  const [logoUrl, setLogoUrl] = useState<string>(businessLogo ?? "");
  const [isLogoBroken, setIsLogoBroken] = useState(false);

  useEffect(() => {
    if (!businessLogo && businessId) {
      fetchBusinessLogo(businessId);
    }
  }, [businessLogo, businessId]);

  const fetchBusinessLogo = async (id: string) => {
    try {
      const response = await getTaxProInfo(id);
      if (response?.data.content.logoUrl) {
        setLogoUrl(response.data.content.logoUrl);
      } else {
        setLogoUrl(fallbackImage);
      }
    } catch (error) {
      console.error("Error fetching business logo:", error);
      setLogoUrl(fallbackImage);
    }
  };

  return {
    logoUrl: isLogoBroken ? fallbackImage : logoUrl,
    handleLogoError: () => setIsLogoBroken(true),
  };
};

export default useLogo;
